import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Staff } from '../models/interfaces';
import { FIRST_AVAILABLE_STAFF_ID } from '../models/consts';
import { StringUtils } from '../utils';

@Pipe({
  name: 'staffNameFormatter',
  pure: false,
})
export class StaffNameFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(staff: Staff, staffId?: number, isPassive?: boolean): string {
    if (!staffId || staffId === FIRST_AVAILABLE_STAFF_ID) {
      return this.translateService.instant(
        isPassive
          ? 'pipes.text.first-available-staff-passive'
          : 'pipes.text.first-available-staff'
      );
    }

    if (!staff) {
      return this.translateService.instant(
        isPassive
          ? 'pipes.text.deleted-staff-passive'
          : 'pipes.text.deleted-staff'
      );
    }

    return StringUtils.generateFullName(staff?.name, staff?.surname);
  }
}
